"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PanelComponentRegistrationContext = require("../context/PanelComponentRegistrationContext");

var UIPanelBody = (0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
      className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className"]);
  return _react.default.createElement("div", Object.assign({}, rest, {
    className: (0, _classnames.default)(className, 'private-panel__body'),
    ref: ref
  }), _react.default.createElement(_PanelComponentRegistrationContext.RegistersPanelBody, null), children);
});
UIPanelBody.propTypes = {
  children: _propTypes.default.node
};
UIPanelBody.displayName = 'UIPanelBody';
var _default = UIPanelBody;
exports.default = _default;
module.exports = exports.default;